import storageFactory from "./storageFactory";

const localStore = storageFactory(() => localStorage);
const sessionStore = storageFactory(() => sessionStorage);

const storageKey = "fluencyState";

const load = (storage) => () => {
  try {
    const serializedState = storage.getItem(storageKey);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const save = (storage) => (state) => {
  try {
    const serializedState = JSON.stringify(state);
    storage.setItem(storageKey, serializedState);
  } catch (err) {
    console.error("Failed to save state to local/session storage: ", err);
    // Ignore write errors.
  }
};
const remove = (storageKey) => {
  try {
    localStore.removeItem(storageKey);
    sessionStore.removeItem(storageKey);
  } catch (err) {
    console.error("Failed to save state to local/session storage: ", err);
    // Ignore write errors.
  }
};

export const loadState = () => {
  const localState = load(localStore)();
  const sessionState = load(sessionStore)();

  return {
    ...localState,
    ...sessionState,
  };
};
export const clearStorage = (storageKey) => remove(storageKey);

export const saveToLocalStorage = (state) => save(localStore)(state);
export const saveToSessionStorage = (state) => save(sessionStore)(state);
